import {React, useEffect, useState} from "react";
import './requestModal.css';
import { createPortal } from "react-dom";
import {deleteVideos} from "../../services/content";

const RequestModal = function ({open, text, button, data}) {

    //message text
    const [message, setMessage] = useState(text);
    //message text
    const [buttonText, setButtonText] = useState(button);

    useEffect( () => {
        setMessage(text);
        setButtonText(button);

    },[text,button]);

    //delete checked rows
    const DeleteRows = async() => {
        let flag = false;
        let m_text = "";
        for (let i=0; i < data.length; i++) {
            let tag_id = data[i];
            let bodyFormData = new FormData();
            bodyFormData.append('tag_id', tag_id);
            const status = await deleteVideos(bodyFormData);
            if (status !== 'success'){
                m_text = "There were problem in the process. \n Please try again"
                flag = true;
                i = data.length;
            }
        }
        if (flag === false) {
            m_text = "All tags deleted successfully!"
        }
        setMessage(m_text);
        setButtonText("OK");
    }

    const handleButton = function () {
        if (buttonText === 'OK'){
            return window.location.reload()
        }
        return DeleteRows();
    }


    return open
    ? createPortal(
        <div className="table-page">
            <div className="modal-page">
                <div className="wrapper">
                        <div className="left">
                        </div>
                        <div className="right">
                            <div className="x-btn-container">
                                <button className="btn-cancel" onClick={() => document.location.reload()}>X</button>
                            </div>
                            <div className="form-right-title">
                               <span className="modal-text">{message}</span>
                            </div>
                            <div className="btn-container">
                                <button className="btn" onClick={handleButton}>{buttonText}</button>
                            </div>
                        </div>
                </div>
            </div>
        </div>, document.body )
    : null } ;

export default RequestModal;